package org.hs_soft.runmynesto.domain.model.home.template

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class GridItemsFilterEnum(
    val value: Boolean?
) : TitleEnum {
    ALL_ITEMS(value = null),
    ACTIVE_ITEMS(value = true),
    INACTIVE_ITEMS(value = false);

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            ALL_ITEMS -> strings.allItems
            ACTIVE_ITEMS -> strings.activeItems
            INACTIVE_ITEMS -> strings.inactiveItems
        }
    }

    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                ALL_ITEMS -> strings.allItems
                ACTIVE_ITEMS -> strings.activeItems
                INACTIVE_ITEMS -> strings.inactiveItems
            }
        }
}